import Timer from '@wetransfer/concorde-timer';

export const RotationService = {
  isPaused: false,
  timer: null,

  start(rotationInterval, callback) {
    // Start a new timer and rotate the wallpaper
    this.timer = new Timer(rotationInterval, callback);
  },

  startOrResume(rotationInterval, callback) {
    // If rotation is on going, ignore.
    if (this.timer && !this.isPaused) return;

    // Start the first rotation
    if (!this.timer) {
      this.isPaused = false;
      return this.start(rotationInterval, callback);
    }

    this.isPaused = false;
    return this.timer.resume();
  },

  pause() {
    // Already pause, do nothing
    if (this.isPaused) return;

    // It's not possible to pause something that didn't even start
    if (!this.timer) return;

    this.timer.pause();
    this.isPaused = true;
  },

  stop() {
    // Stop the running timer
    if (this.timer) {
      this.timer.stop();
    }

    this.isPaused = false;
    this.timer = null;
  },

  reset() {
    // Reset running timer => stop and start from the beginning again
    this.timer.reset();
  },

  get remainingTime() {
    return this.timer.remainingTime;
  },
};
